module.exports = __webpack_public_path__ + "9a7739501b110ab1c60d6b51264f7fb8.svg";